/**************************************************
 * Nombre:       Seccione_Recibo
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Testimonios from "./Componentes/SubComponentes/Testimonios";
import Home_Contactos from "./Componentes/Home_Contactos";
import {useEffect, useState} from "react";
import Nosotros_Logos from "./Componentes/Nosotros_Logos";
import Nosotros_Aportes from "./Componentes/Nosotros_Aportes";
import Recibo_Portada from "./Componentes/Recibo_Portada";
import {obtenerParametro} from "../../Modulo_Recibo/Funciones/obtenerParametro";
import {obtenerDoc} from "../../Servicios/BD/obtenerDoc";
import {obtenerEstadoPago} from "../../Modulo_Mercado_Pago/Funciones/obtenerEstadoPago";

const Seccione_Recibo = () => {

    const [pedido, setPedido] = useState({})
    const [pago, setPago] = useState({})


    useEffect(() => {


        let idPedido = obtenerParametro('external_reference')
        console.log(idPedido)
        obtenerDoc('pedidos', idPedido).then(dox => {
            if (dox.res) {
                setPedido(dox.data)
            }
        })

        let idPago = obtenerParametro('payment_id')
        obtenerEstadoPago({idPago: idPago}).then(dox => {
            setPago(dox)
        })


    }, [])
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Recibo_Portada pago={pago} pedido={pedido}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Nosotros_Logos/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 4}}>
                <Nosotros_Aportes/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 12}}>
                <Testimonios/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Home_Contactos/>
            </Grid>

        </Grid>
    )

}
export default Seccione_Recibo